import aaeLogo from './aae_logo.svg';
import campEagleLogo from './camp_eagle_logo.svg';
import qcsoLogo from './qsco_logo.svg';
import sameLogo from './same_logo.svg';
import unitedWayLogo from './united_way_logo.svg';

import aaeBackground from './aae_background.jpg';
import campEagleBackground from './camp_eagle_background.jpg';
import feathrLogo from './feathr_logo.jpg';
import qcsoBackground from './qsco_background.jpg';
import sameBackground from './same_background.jpg';
import unitedWayBackground from './united_way_background.jpg';
import feathrBackgroundOne from './webinar-august-27-2025.jpg';
import feathrBackgroundOneStock from './webinar-august-27-2025-stock.jpg';
import feathrBackgroundTwo from './webinar-august-28-2025.jpg';
import feathrBackgroundTwoStock from './webinar-august-28-2025-stock.jpg';

export const backgroundImages = {
  aae: aaeBackground,
  campEagle: campEagleBackground,
  feathrOne: feathrBackgroundOne,
  feathrOneStock: feathrBackgroundOneStock,
  feathrTwo: feathrBackgroundTwo,
  feathrTwoStock: feathrBackgroundTwoStock,
  qcso: qcsoBackground,
  same: sameBackground,
  unitedWay: unitedWayBackground,
};

export const logos = {
  aae: aaeLogo,
  campEagle: campEagleLogo,
  feathr: feathrLogo,
  qcso: qcsoLogo,
  same: sameLogo,
  unitedWay: unitedWayLogo,
};
